<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader @custom-event="getToken"></cnHeader>
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/cn">首页</a><span class="space">/</span><a href="/cn/user/index">我的账户</a><span class="space">/</span>账单详情
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			<!--页面内容-开始-->
			<div class="error_box" v-if="errStatus">
				<h3>{{errMessage}}</h3>
			</div>
			<div class="order_main_box" v-if="!errStatus">
				<div class="omb_left">
					<h1>账单详情</h1>
					<!--套餐-开始-->
					<div v-if="orderDetail.OrderType==0">
						<div class="ol_item">
							<h3>基础信息</h3>
							<div class="oll_box">
								<ul>
									<li>
										<div class="title">账单编号：</div>
										<div class="content">{{orderDetail.OrderNo}}</div>
									</li>
									<li>
										<div class="title">账单类型：</div>
										<div class="content">{{orderDetail.OrderTypeTxt}}</div>
									</li>
									<li>
										<div class="title">下单时间：</div>
										<div class="content">{{orderDetail.Time}}</div>
									</li>
									<li>
										<div class="title">套餐名称：</div>
										<div class="content">{{orderDetail.ProductOrder.Title}}</div>
									</li>
									<li>
										<div class="title">住宿方案：</div>
										<div class="content">{{orderDetail.ProductOrder.PlanName}}</div>
									</li>
									<li>
										<div class="title">行程时间：</div>
										<div class="content">{{orderDetail.ProductOrder.BeginDate}} 至 {{orderDetail.ProductOrder.EndDate}}</div>
									</li>
								</ul>
							</div>
						</div>
						<div class="ol_item" style="padding-bottom: 25px;">
							<h3>酒店信息</h3>
							<div class="oll_box">
								<ul>
									<li>
										<div class="title">房间数量：</div>
										<div class="content">{{orderDetail.ProductOrder.RoomAmount}} 间</div>
									</li>
									<li>
										<div class="title">入住酒店：</div>
										<div class="content">
											<p v-for="(item, index) in orderDetail.ProductOrder.HotelList" :key="index">{{item.HotelName}}（{{item.RoomType}}）</p>
										</div>
									</li>
									<li>
										<div class="title">客人数量：</div>
										<div class="content">{{orderDetail.ProductOrder.PersonAmount}} 人</div>
									</li>
									<li>
										<div class="title">客人清单：</div>
										<div class="content">
											<div class="room_box">
												<div class="room" v-for="(item, index) in orderDetail.ProductOrder.RoomList" :key="index">
													<h5>{{item.Title}}</h5>
													<p v-for="(x, y) in item.PersonList" :key="y">{{x.RealName}}，{{x.Age}}岁</p>
												</div>
											</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<!--套餐-结束-->
					
					<!--玩乐-开始-->
					<div v-if="orderDetail.OrderType==2">
						<div class="ol_item">
							<h3>基础信息</h3>
							<div class="oll_box">
								<ul>
									<li>
										<div class="title">账单编号：</div>
										<div class="content">{{orderDetail.OrderNo}}</div>
									</li>
									<li>
										<div class="title">账单类型：</div>
										<div class="content">{{orderDetail.OrderTypeTxt}}</div>
									</li>
									<li>
										<div class="title">下单时间：</div>
										<div class="content">{{orderDetail.Time}}</div>
									</li>
									<li>
										<div class="title">玩乐名称：</div>
										<div class="content">{{orderDetail.RecreationOrder.Title}}</div>
									</li>
									<li>
										<div class="title">预订日期：</div>
										<div class="content">{{orderDetail.RecreationOrder.BookingDate}}</div>
									</li>
								</ul>
							</div>
						</div>
						<div class="ol_item">
							<h3>客人信息</h3>
							<div class="oll_box">
								<ul>
									<li>
										<div class="title">客人数量：</div>
										<div class="content">{{orderDetail.RecreationOrder.PersonAmount}} 人</div>
									</li>
									<li>
										<div class="title">客人清单：</div>
										<div class="content">
											<p v-for="(item, index) in orderDetail.RecreationOrder.PersonList" :key="index">{{item.RealName}}，{{item.Sex}}，{{item.Age}}岁</p>
										</div>
									</li>									
								</ul>
							</div>
						</div>
						<div class="ol_item">
							<h3>酒店信息</h3>
							<div class="oll_box">
								<ul>
									<li>
										<div class="title">酒店名称：</div>
										<div class="content">{{orderDetail.RecreationOrder.HotelName}}</div>
									</li>
									<li>
										<div class="title">酒店地址：</div>
										<div class="content">{{orderDetail.RecreationOrder.HotelAddress}}</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<!--玩乐-结束-->
					
					<!--酒店-开始-->
					<div v-if="orderDetail.OrderType==1">
						<div class="ol_item">
							<h3>基础信息</h3>
							<div class="oll_box">
								<ul>
									<li>
										<div class="title">账单编号：</div>
										<div class="content">{{orderDetail.OrderNo}}</div>
									</li>
									<li>
										<div class="title">账单类型：</div>
										<div class="content">{{orderDetail.OrderTypeTxt}}</div>
									</li>
									<li>
										<div class="title">下单时间：</div>
										<div class="content">{{orderDetail.Time}}</div>
									</li>
									<li>
										<div class="title">酒店名称：</div>
										<div class="content">{{orderDetail.HotelOrder.Title}}（{{orderDetail.HotelOrder.RoomType}}）</div>
									</li>
									<li>
										<div class="title">房间数量：</div>
										<div class="content">{{orderDetail.HotelOrder.RoomAmount}} 间</div>
									</li>
								</ul>
							</div>
						</div>
						<div class="ol_item">
							<h3>预订日期</h3>
							<div class="oll_box">
								<ul>
									<li>
										<div class="title">入住时间：</div>
										<div class="content">{{orderDetail.HotelOrder.BeginDate}}</div>
									</li>
									<li>
										<div class="title">退房时间：</div>
										<div class="content">{{orderDetail.HotelOrder.EndDate}}</div>
									</li>
								</ul>
							</div>							
						</div>
						<div class="ol_item">
							<h3>客人信息</h3>
							<div class="oll_box">
								<ul>
									<li>
										<div class="title">客人数量：</div>
										<div class="content">{{orderDetail.HotelOrder.PersonAmount}} 人</div>
									</li>
									<li>
										<div class="title">客人清单：</div>
										<div class="content">
											<div class="room_box">
												<div class="room" v-for="(item, index) in orderDetail.HotelOrder.RoomList" :key="index">
													<h5>{{item.Title}}</h5>
													<p v-for="(x, y) in item.PersonList" :key="y">{{x.RealName}}，{{x.Age}}岁</p>
												</div>
											</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<!--酒店-结束-->
					
					<!--景点门票-开始-->
					<div v-if="orderDetail.OrderType==4">
						<div class="ol_item">
							<h3>基础信息</h3>
							<div class="oll_box">
								<ul>
									<li>
										<div class="title">账单编号：</div>
										<div class="content">{{orderDetail.OrderNo}}</div>
									</li>
									<li>
										<div class="title">账单类型：</div>
										<div class="content">{{orderDetail.OrderTypeTxt}}</div>
									</li>
									<li>
										<div class="title">下单时间：</div>
										<div class="content">{{orderDetail.Time}}</div>
									</li>
									<li>
										<div class="title">景点名称：</div>
										<div class="content">{{orderDetail.TicketOrder.Title}}</div>
									</li>
									<li>
										<div class="title">票面日期：</div>
										<div class="content">{{orderDetail.TicketOrder.BookingDate}}</div>
									</li>
									<li>
										<div class="title">数量：</div>
										<div class="content">{{orderDetail.TicketOrder.PersonAmount}} 张</div>
									</li>
								</ul>
							</div>
						</div>
						<div class="ol_item">
							<h3>客人信息</h3>
							<div class="oll_box">
								<ul>
									<li>
										<div class="title">客人清单：</div>
										<div class="content">
											<p v-for="(item, index) in orderDetail.TicketOrder.PersonList" :key="index">{{item.RealName}}，{{item.Sex}}，{{item.Age}}岁</p>
										</div>
									</li>									
								</ul>
							</div>
						</div>
					</div>
					<!--景点门票-结束-->
					
					<!--公共-开始-->
					<div>
						<div class="ol_item" style="margin-top: 40px;">
							<h3>联系人信息</h3>
							<div class="oll_box">
								<ul>
									<li>
										<div class="title">姓名：</div>
										<div class="content">{{orderDetail.LinkMan}}</div>
									</li>
									<li>
										<div class="title">手机：</div>
										<div class="content">{{orderDetail.Mobile}}</div>
									</li>
									<li>
										<div class="title">邮箱：</div>
										<div class="content">{{orderDetail.Email}}</div>
									</li>
								</ul>
							</div>
						</div>
						<div class="ol_item" style="padding-bottom: 0; border: 0;">
							<h3>备注信息</h3>
							<div class="oll_box">
								<ul>
									<li v-if="orderDetail.OrderType == 2 && orderDetail.RecreationOrder.FlightNo !=''">
										<div class="title">航班号：</div>
										<div class="content">{{orderDetail.RecreationOrder.FlightNo}}</div>
									</li>
									<li>
										<div class="title">客户留言：</div>
										<div class="content">{{orderDetail.Remark!=''?orderDetail.Remark:'无'}}</div>
									</li>
									<li v-if="orderDetail.OpRemark!=''">
										<div class="title">平台回复：</div>
										<div class="content">{{orderDetail.OpRemark}}</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<!--公共-结束-->
				</div>
				<div class="omb_right">
					<div class="price_box">
						<div class="price">${{orderDetail.PayablePrice}}</div>
						<div class="ext_price">含州税 ${{orderDetail.TaxPrice}}</div>
						<div class="status">{{orderDetail.StatusTxt}}{{orderDetail.Status==2?'，请于 '+orderDetail.ValidPayTime+' 前完成支付':''}}</div>
						<!-- <div class="tips" v-if="orderDetail.OpRemark!=''">{{orderDetail.OpRemark}}</div> -->
						<div class="pay_box">
							<div class="button_box" v-if="orderDetail.Status==2">
								<el-button type="primary" round :loading="btnLoading" @click="payHandle()">{{btnTxt}}</el-button>
								<div v-html="orderDetail.AuthorizeNetForm"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--页面内容-结束-->
		</div>
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	import {
		checkToken,
		getOrderDetail,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnFooter from '@/components/cn_footer.vue'
	export default {
		name: 'CN_UserOrderDetail',
		mixins: [mixin],
		components: {
			cnHeader,
			cnFooter,
		},
		data() {
			return {
				fullscreenLoading: true, //loading状态
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				
				errStatus: false,
				errMessage: '错误：非正常加载页面',
				
				orderNo:'',
				orderDetail:[],
				
				btnLoading: false,
				btnTxt: '立即支付',
			}
		},
		created() {
			// 获取orderNo
			if (this.$route.query.OrderNo != undefined && this.$route.query.OrderNo !='') {
				this.orderNo = this.$route.query.OrderNo
				
				console.log(this.orderNo)
			}
			else
			{
				this.errStatus = true
				this.errMessage = '错误：账单号不能为空'
			}
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
					
					this.getData()
				}
				else				
				{
					this.$router.push({
						path: '/cn/user/login?ReturnUrl=' + encodeURIComponent(window.location.href)
					})
				}
			},
			//获取数据
			async getData() {
				const { data: res } = await getOrderDetail(this.language, this.token, this.terminal, this.orderNo)				
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.orderDetail = res.data
				} else {
					this.errStatus = true
					this.errMessage = '错误：'+res.errmsg
				}
			},
			//立即支付
			payHandle()
			{
				if(this.btnLoading)
				{
					return
				}
				
				this.btnLoading = true
				this.btnTxt = "请求支付中，请稍侯..."
				
				const form = document.getElementById('visa_post_form');
				if (form) {
					form.submit(); // 提交表单
				} else {
					this.$message.error("支付请求失败，请稍侯再试！");
				}
				this.btnLoading = true
				this.btnTxt = "立即支付"
			}
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		.error_box {
			min-height: 700px;
			text-align: center;
			box-sizing: border-box;
			padding-top: 300px;
			
			h3 {
				font-size: 28px;
			}
		}
		
		.order_title {
			margin-top: 20px;
			line-height: 140%;
			font-size: 28px;
			font-weight: 500;
		}
		
		.order_main_box {
			min-height: 600px;
			margin-top: 40px;
			margin-bottom: 80px;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			border: #3D7856 solid 2px;
			border-radius: 8px;
			box-sizing: border-box;
			background-color: #fff;
			background-position: 1000px 100%;
			background-repeat: repeat-y;
			background-image: url(@/assets/images/icons/shu_line.png);
			padding: 30px;
			box-shadow: 0 10px 20px #ddd;
			
			.omb_left {
				width: 940px;
				box-sizing: border-box;
				padding-bottom: 40px;
				
				h1 {					
					line-height: 140%;
					font-size: 24px;
					font-weight: 500;
				}
				
				
				.ol_item {
					margin-top: 40px;
					border-bottom: #e4e4e4 dotted 1px;
					padding-bottom: 40px;
					display: flex;
					justify-content: flex-start;
					
					h3 {
						width: 110px;
						font-size: 18px;
						font-weight: 500;
						text-align: right;
						margin-right: 40px;
					}
					
					.oll_box {
						width: 830px;
						ul {							
							li {
								display: flex;
								margin-top: 10px;
								font-size: 14px;
								
								.title {
									width: 11%;
									box-sizing: border-box;
									text-align: right;
									padding-right: 8px;
									color: #666;
								}
								.content {
									width: 89%;
									
									.room_box {
										display: flex;
										flex-wrap: wrap;
										
										.room {
											width: 48%;
											box-sizing: border-box;
											margin: 0 14px 15px 0;
											padding: 12px;
											background-color: #f9f9f9;
											border-radius: 8px;
											
											h5 {
												font-size: 15px;
												font-weight: 500;
												margin-left: 0;
											}
											p {
												margin-top: 8px;
											}
										}
									}
								}
							}
							li:first-child {
								margin-top: 0;
							}
						}
					}
				}
			}
			
			.omb_right {
				width: 290px;
				box-sizing: border-box;
				
				.price_box {
					text-align: right;
				
					.price {
						margin-top: 10px;
						font-size: 28px;
						font-weight: 500;
					}
					.ext_price {
						margin-top: 6px;
						font-size: 14px;
						color: #888;
						font-style: italic;
					}
					
					.status {
						margin-top: 10px;
						font-size: 13px;
						font-style: italic;
					}
					
					.tips {
						margin-top: 10px;
						display: inline-block;
						height: 26px;
						line-height: 26px;
						border-radius: 13px;
						font-size: 12px;
						color: #ff6600;
						background-color: #FFEFE0;
						background-image: url(@/assets/images/icons/d_tip.png);
						background-repeat: no-repeat;
						background-position: 12px center;
						background-size: 13px 12px;
						padding: 0 10px 0 30px;
					}
					
					.pay_box {
						width: 100%;
						margin-top: 60px;
						
						.button_box {
							margin-top: 30px;
						}
					}
				}
			}
		}
		
		.el-button {
			width: 100%;
			font-family: "PingFang SC", sans-serif, Helvetica, Arial;
			font-size: 15px;
			font-weight: 400;
			height: 42px;
			border-radius: 21px;
			-webkit-transition: all .3s ease;
		}
		.el-button--default {
			border: #666 solid 1px;
			color: #666;
			margin-left: 20px;
		}
		.el-button--default:hover {
			border: #008768 solid 1px;
			color: #008768;
		}
		.el-button.is-plain:focus  {
			border: #008768 solid 1px;
			color: #008768;
		}
		
		.el-button--primary {
			border: 0;
		}		
		.el-button--primary:focus {
			background-color: #008768;
		}
		.el-button--primary:hover {
			background-color: #000;
		}
	}
</style>